<template>
  <div>
    <Head title="Contact" />
    <!-- Start Hero -->
    <section class="relative z-10 overflow-hidden bg-primary pt-[120px] pb-[100px] md:pt-[130px] lg:pt-[160px]">
      <div class="container">
        <div class="-mx-4 flex flex-wrap items-center">
          <div class="w-full px-4">
            <div class="text-center">
              <h1 class="text-4xl font-semibold text-white">{{ __(data.title) }}</h1>
            </div>
          </div>
        </div><!--end grid-->
      </div><!--end container-->
      <div>
        <span class="absolute top-0 left-0 z-[-1]">
          <img src="/landing/images/header/shape-1.svg" alt="" />
        </span>
        <span class="absolute top-0 right-0 z-[-1]">
          <img src="/landing/images/header/shape-2.svg" alt="" />
        </span>
      </div>
    </section><!--end section-->
    <!-- End Hero -->

    <!-- ====== Contact Section Start -->
    <section class="relative z-10 overflow-hidden bg-white py-20 lg:py-[120px]">
      <div class="container mx-auto">
        <div class="-mx-4 flex flex-wrap lg:justify-between">
          <div class="w-full px-4 lg:w-1/2 xl:w-6/12">
            <div class="mb-12 max-w-[570px] lg:mb-0">
              <h2 class="text-dark mb-6 text-[32px] font-bold uppercase sm:text-[40px] lg:text-[36px] xl:text-[40px]">
                {{ page.content_text }}
              </h2>
              <p class="text-body-color mb-9 text-base leading-relaxed">
                {{ page.content_details }}
              </p>
              <div class="mb-8 flex w-full max-w-[370px]">
                <div
                  class="bg-primary text-white mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]"
                >
                  <icon name="home" class="w-8 h-8" />
                </div>
                <div class="w-full">
                  <h4 class="text-dark mb-1 text-xl font-bold">{{ 'Our Location' }}</h4>
                  <p class="text-body-color text-base" v-html="sanitizeHtml(page.location)" />
                </div>
              </div>
              <div class="mb-8 flex w-full max-w-[370px]">
                <div class="bg-primary text-primary mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]">
                  <icon name="phone" class="w-8 h-8 fill-white" />
                </div>
                <div class="w-full">
                  <h4 class="text-dark mb-1 text-xl font-bold">{{ 'Phone Number' }}</h4>
                  <p class="text-body-color text-base"><a :href="'tel:' + page.phone">{{ page.phone }}</a></p>
                </div>
              </div>
              <div class="mb-8 flex w-full max-w-[370px]">
                <div
                  class="bg-primary text-primary mr-6 flex h-[60px] w-full max-w-[60px] items-center justify-center overflow-hidden rounded bg-opacity-5 sm:h-[70px] sm:max-w-[70px]"
                >
                  <icon name="email" class="w-8 h-8 fill-white" />
                </div>
                <div class="w-full">
                  <h4 class="text-dark mb-1 text-xl font-bold">{{ 'Email Address' }}</h4>
                  <p class="text-body-color text-base"><a :href="'mailto:' + page.email">{{ page.email }}</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full px-4 lg:w-1/2 xl:w-5/12">
            <div class="relative rounded-lg bg-white p-8 shadow-lg sm:p-12">
              <form class="card mt-2 p-4 rounded shadow-xl overflow-hidden" method="post" @submit.prevent="store">
                <div class="mb-6">
                  <text-input v-model="form.name" :error="form.errors.name" placeholder="Your Name" />
                </div>
                <div class="mb-6">
                  <text-input v-model="form.email" :error="form.errors.email" placeholder="Your Email" />
                </div>
                <div class="mb-6">
                  <vue-tel-input v-model="form.phone" placeholder="Enter Mobile Number" default-country-code="IN" mode="international" valid-characters-only="true" @validate="phoneInputChange" @country-changed="countryChange"/>
                  <div v-if="form.errors.phone" class="form-error">{{ form.errors.phone }}</div>
                </div>
                <div class="mb-6">
                  <textarea-input v-model="form.message" name="content" :error="form.errors.message" placeholder="Your Message" />
                </div>
                <div>
                  <button
                    type="submit"
                    class="bg-primary border-primary w-full rounded border p-3 text-white transition hover:bg-opacity-90 cursor-pointer"
                  >
                    Send Message
                  </button>
                </div>
              </form>
              <div>
                <span class="absolute -top-10 -right-9 z-[-1]">
                  <img src="/landing/images/contact/shape-1.svg" alt="" />
                </span>
                <span class="absolute -right-10 top-[90px] z-[-1]">
                  <img src="/landing/images/contact/shape-2.svg" alt="" />

                </span>
                <span class="absolute -left-7 -bottom-7 z-[-1]">
                  <img src="/landing/images/contact/shape-3.svg" alt="" />

                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ====== Contact Section End -->
  </div>
</template>
<script>

import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import TextInput from '@/Shared/TextInput'
import { Head } from '@inertiajs/vue3'
import sanitizeHtml from 'sanitize-html'
import TextareaInput from '@/Shared/TextareaInput'
// import VueTelInput from '@/Shared/PhoneNumberInput'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

export default {
    components: {
        Icon,
        Head,
        TextInput,
        TextareaInput,
        VueTelInput,
    },
    layout: Layout,
    props: {
        data: Object,
    },
    data() {
        return {
            page: JSON.parse(this.data.html),
            form: this.$inertia.form({
                name: '',
                email: '',
                phone: '',
                message: '',
                pal: 'test',
            }),
        }
    },
    methods:{
        sanitizeHtml : sanitizeHtml,
        phoneInputChange(e) {
            if (e.valid === false) {
                this.form.errors.phone = 'The phone format is invalid.'
            } else {
                this.form.errors.phone = null
            }
        },
        countryChange(e) {
                this.form.phone = `+${e.dialCode}`
        },
        store() {
            if (this.form.errors.phone)  return;
            this.form.phone = this.form.phone.split(' ').join('')
            console.log('this.form :>> ', this.form.phone)
            this.form.post(this.route('contact.send'),{
                onSuccess: () => {
                    this.form.reset()
                },
            })
        },
    },
}
</script>
